import { render } from "./MarkdownBody.vue?vue&type=template&id=50f842e9"
import script from "./MarkdownBody.vue?vue&type=script&lang=js"
export * from "./MarkdownBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__